const TEST_MESSAGE_OPT_IN = `Success! We’ve sent you a text message.
  To confirm your request, please respond with a "Y"`;
const NO_EXISTING_PREFERENCES_FOUND = 'Success! You can now select your preferences.';
const EXISTING_PREFERENCES_FOUND = `We found preferences tied to this email and/or phone number.
You can manage your preferences below.`;
const PREFERENCES_UPDATED = 'Success! Your preferences have been updated.';

const PHONE_OPT_OUT_CONFIRMATION = ' has been successfully added to The Home Depot\'s Internal Do Not Call List.';

const POSTAL_OPT_OUT_CONFIRMATION = ' has been successfully unsubscribed from postal mail. '
  + 'Please allow 6-8 weeks for this process to take effect.';

const SURVEY_OPT_OUT_CONFIRMATION = ' has been successfully unsubscribed from all survey emails.';

const FCC_OPTOUT = ' has been successfully opted out from all marketing text messages. '
  + 'You have also been added to The Home Depot’s Do Not Call List.';

export const HOME_DEPOT_MARKETING_UNSUBSCRIBE_SUCCESS = ' has been successfully '
  + 'unsubscribed from The Home Depot marketing list.';
export const HOME_DEPOT_MARKETING_SUBSCRIBE_SUCCESS = ' has been successfully subscribed to '
  + 'The Home Depot marketing list.';
export const LOCAL_AD_MARKETING_EMAIL_UNSUBSCRIBE_SUCCESS = ' has been successfully '
  + 'unsubscribed from the Local Ad marketing list.';
export const LOCAL_AD_MARKETING_EMAIL_SUBSCRIBE_SUCCESS = ' has been successfully subscribed to '
  + 'the Local Ad marketing list.';
export const SPECIAL_BUY_MARKETING_EMAIL_UNSUBSCRIBE_SUCCESS = ' has been successfully '
  + 'unsubscribed from the Daily Deals marketing list.';
export const SPECIAL_BUY_MARKETING_EMAIL_SUBSCRIBE_SUCCESS = ' has been successfully subscribed to '
  + 'the Daily Deals marketing list.';
export const PRO_MARKETING_UNSUBSCRIBE_SUCCESS = ' has been successfully unsubscribed '
  + 'from the Pro Communications marketing list.';
export const PRO_MARKETING_SUBSCRIBE_SUCCESS = ' has been successfully subscribed to the '
  + 'Pro Communications marketing list.';
export const ALL_EMAIL_UNSUBSCRIBE_SUCCESS = ' has been successfully unsubscribed from all '
  + 'marketing emails.';
export const SURVEY_EMAIL_SUBSCRIBE_SUCCESS = ' preferences has been updated and is subscribed to Surveys.';
export const SURVEY_EMAIL_UNSUBSCRIBE_SUCCESS = ' preferences has been updated and is unsubscribed from Surveys.';
export const UNSUBSCRIBE_MESSAGES = {
  PRO: PRO_MARKETING_UNSUBSCRIBE_SUCCESS,
  PROMOTIONS: HOME_DEPOT_MARKETING_UNSUBSCRIBE_SUCCESS,
  LOCAL_AD: LOCAL_AD_MARKETING_EMAIL_UNSUBSCRIBE_SUCCESS,
  SPECIAL_BUY_OF_THE_DAY: SPECIAL_BUY_MARKETING_EMAIL_UNSUBSCRIBE_SUCCESS,
  SURVEYS: SURVEY_EMAIL_UNSUBSCRIBE_SUCCESS
};

export const SUBSCRIBE_MESSAGES = {
  PRO: PRO_MARKETING_SUBSCRIBE_SUCCESS,
  PROMOTIONS: HOME_DEPOT_MARKETING_SUBSCRIBE_SUCCESS,
  LOCAL_AD: LOCAL_AD_MARKETING_EMAIL_SUBSCRIBE_SUCCESS,
  SPECIAL_BUY_OF_THE_DAY: SPECIAL_BUY_MARKETING_EMAIL_SUBSCRIBE_SUCCESS,
  SURVEYS: SURVEY_EMAIL_SUBSCRIBE_SUCCESS
};

export default {
  TEST_MESSAGE_OPT_IN,
  NO_EXISTING_PREFERENCES_FOUND,
  EXISTING_PREFERENCES_FOUND,
  PREFERENCES_UPDATED,
  PHONE_OPT_OUT_CONFIRMATION,
  POSTAL_OPT_OUT_CONFIRMATION,
  SURVEY_OPT_OUT_CONFIRMATION,
  FCC_OPTOUT
};
